<template>
  <div>
    <header-section></header-section>
    <info-counselor 
      :info_page="info_page">
    </info-counselor>
  </div>  
  <!-- <info-counselor></info-counselor> -->
</template>
<script>
  import HeaderSection from "./components/Common/HeaderSection.vue";
  import InfoCounselor from './components/Counselor/InfoCounselor.vue';
  var url = process.env.API_URL + process.env.API_VERSION;
  export default{
    name: "components",
    components: {
      HeaderSection,
      InfoCounselor
    },
    data: function(){
      return{
        info_page:{
          status_page: 'counselor-information',
          user_info: {}
        }        
      }
    },
    // prop:[]
    created: function(){
      this.$http
        .get(url + '/users/counselor?id=' + this.$route.query.id)
        .then((response) =>{
          this.info_page.user_info = response.data.extra.counselor;        
        })        
        .catch((error) =>{
          console.log(error);
        });
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/CounselorInformation.vue